import { render, staticRenderFns } from "./InsuranceListing.vue?vue&type=template&id=242a2955"
import script from "./InsuranceListing.vue?vue&type=script&lang=js"
export * from "./InsuranceListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports